'use client';

import { Copy, ExternalLink, Gift } from 'lucide-react';
import { useState } from 'react';

interface RewardProps {
  reward: {
    id: string;
    name: string;
    description: string;
    type: string;
    imageUrl: string | null;
    link?: string;
    couponId?: string;
    coupon?: {
      guid: string;
      code: string;
      description: string;
      discountType: string;
      discountValue: string;
      isActive: boolean;
      maxDiscountAmount: number | null;
    };
  };
}

export default function RewardBanner({ reward }: RewardProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  const handleCopyCode = async () => {
    if (reward?.coupon?.code) {
      try {
        await navigator.clipboard.writeText(reward.coupon.code.trim());
        // toast({
        //   title: 'Coupon code copied!',
        //   description: `${reward.coupon.code.trim()} has been copied to your clipboard.`,
        // });
      } catch (err) {
        // Fallback for browsers that don't support clipboard API
        const textArea = document.createElement('textarea');
        textArea.value = reward.coupon.code.trim();
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        // toast({
        //   title: 'Coupon code copied!',
        //   description: `${reward.coupon.code.trim()} has been copied to your clipboard.`,
        // });
      }
    }
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  const getDiscountText = () => {
    if (!reward.coupon) return '';

    const { discountType, discountValue, maxDiscountAmount } = reward.coupon;

    if (discountType === 'percentage') {
      return maxDiscountAmount
        ? `${discountValue}% OFF (up to ${maxDiscountAmount})`
        : `${discountValue}% OFF`;
    }

    return `${discountValue} OFF`;
  };

  return (
    <div className="relative mb-4 rounded-lg overflow-hidden">
      <div
        className={`p-4 flex justify-between ${
          reward?.type === 'COUPON' ? 'bg-amber-50' : 'bg-blue-50'
        } border ${reward?.type === 'COUPON' ? 'border-amber-200' : 'border-blue-200'}`}
      >
        {/* <button className="absolute top-2 right-2 h-6 w-6" onClick={handleClose}>
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </button> */}

        <div className="flex items-start gap-3">
          <div className="mt-0.5 flex-shrink-0">
            <Gift className={`h-5 w-5 ${reward?.type === 'COUPON' ? 'text-amber-600' : 'text-blue-600'}`} />
          </div>

          <div className="flex-1">
            <h3 className="font-medium text-sm">{reward?.name}</h3>
            <p className="text-sm text-muted-foreground mt-0.5">{reward?.description}</p>

            {reward?.type === 'COUPON' && reward?.coupon && (
              <div className="mt-2">
                <div className="text-xs font-medium text-muted-foreground mb-1">{getDiscountText()}</div>
                {/* <div className="flex items-center gap-2">
                  <div className="bg-background border rounded px-3 py-1.5 text-sm font-medium">
                    {reward.coupon.code.trim()}
                  </div>
                 
                </div> */}
              </div>
            )}
          </div>
        </div>
        {reward?.type === 'COUPON' && reward?.coupon && (
          <button
            className="h-8 bg-background border bg-black text-white rounded-md px-3 py-1.5 text-sm font-medium flex items-center"
            onClick={handleCopyCode}
          >
            <Copy className="h-3.5 w-3.5 mr-1.5" />
            Copy
          </button>
        )}
        {reward?.type !== 'COUPON' && reward?.link && (
          <div className="mt-2">
            <button
              className="h-8 bg-background border bg-black text-white rounded-md px-3 py-1.5 text-sm font-medium flex items-center"
              onClick={() => {
                window.open(reward.link, '_blank');
                // toast({
                //   title: 'Opening offer link',
                //   description: 'The offer link has been opened in a new tab.',
                // });
              }}
            >
              <ExternalLink className="h-3.5 w-3.5 mr-1.5" />
              View Offer
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
